import React from 'react';

const SVG = ({
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 24 24',
}) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>.cls-2{`fill:${fill};`}</style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="cancel-24px">
        <path
          id="Path_2344"
          data-name="Path 2344"
          className="cls-2"
          d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM15.59,7,12,10.59,8.41,7,7,8.41,10.59,12,7,15.59,8.41,17,12,13.41,15.59,17,17,15.59,13.41,12,17,8.41Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
